// extracted by mini-css-extract-plugin
export default {"popup":"popup___TrB_5"};